<template>
    <div class="subscription-card">
        <div class="delete-sub" @click="$emit('deletePlan')">
            <span class="material-icons">delete</span>
        </div>

        <div class="body">
            <div class="title">{{ subscribe.plan.title }}</div>
            <div class="descriptions">
                <div class="descriptions-item">
                    <div class="label">Paket Türü<span>:</span></div>
                    <div class="value">{{ subscribe.plan.altTitle }}</div>
                </div>
                <div class="descriptions-item">
                    <div class="label">Abonelik Türü<span>:</span></div>
                    <div class="value">{{ subscribe.period == "monthly" ? "Aylık" : "Yıllık" }}</div>
                </div>
                <div class="descriptions-item" v-if="subscribe.plan.type == 'supsis'">
                    <div class="label">Temsilci Sayısı<span>:</span></div>
                    <div class="value">{{ details.agentCount }}</div>
                </div>
                <div
                    class="descriptions-item"
                    v-if="subscribe.plan.type == 'whatsapp' || subscribe.plan.type == 'whatsapp-business'"
                >
                    <div class="label">Kanal Sayısı<span>:</span></div>
                    <div class="value">{{ details.whatsappChannel }}</div>
                </div>
                <div class="descriptions-item" v-else>
                    <div class="label"><span></span></div>
                    <div class="value"></div>
                </div>
            </div>
        </div>
        <div class="image-wrapper">
            <DynamicSvg :name="subscribe.icon" style="width: 80px; height: 80px" />
        </div>
    </div>
</template>

<script>
import DynamicSvg from "../../DynamicSvg.vue";

export default {
    name: "SubscriptionCard",
    props: ["subscribe", "details"],
    components: {
        DynamicSvg,
    },
};
</script>

<style lang="scss">
.subscription-card {
    color: black;
    display: flex;
    align-items: center;
    border: 1px solid #d0d0d0;
    padding: 20px 30px;
    border-radius: 8px;
    position: relative;

    .delete-sub {
        position: absolute;
        top: -20px;
        right: 0px;
        background: #ec4b1d;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        color: white;

        .material-icons {
            font-size: 22px;
        }
    }

    .body {
        flex: 1;
        margin-right: 60px;

        .title {
            font-weight: bold;
            font-size: 22px;
        }

        .descriptions {
            margin-top: 9px;

            &-item {
                display: flex;
                align-content: center;
                font-weight: bolder;
                font-size: 14px;

                &:not(:first-child) {
                    margin-top: 2px;
                }

                .label {
                    color: #999;
                    width: 120px;
                }
            }
        }
    }

    .image-wrapper {
        margin-right: 30px;
        max-width: 30%;
        width: 80px;
        height: 80px;
    }
}
</style>
